import { render, staticRenderFns } from "./DetailPriceDraw.vue?vue&type=template&id=5d057986&scoped=true"
import script from "./DetailPriceDraw.vue?vue&type=script&lang=js"
export * from "./DetailPriceDraw.vue?vue&type=script&lang=js"
import style0 from "./DetailPriceDraw.vue?vue&type=style&index=0&id=5d057986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d057986",
  null
  
)

export default component.exports